"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.sizes = void 0;

var _misc = require("../../misc");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var sizes = {
  h2: {
    fontFamily: "'League Gothic', sans-serif",
    fontWeight: 400,
    fontSize: (0, _misc.pxToRem)(40),
    lineHeight: (0, _misc.pxToRem)(48),
    letterSpacing: (0, _misc.pxToRem)(0.2),
    textTransform: 'uppercase',
    alignSelf: 'center'
  },
  h3: {
    fontFamily: "'League Gothic', sans-serif",
    fontWeight: 400,
    fontSize: (0, _misc.pxToRem)(32),
    lineHeight: (0, _misc.pxToRem)(32),
    letterSpacing: (0, _misc.pxToRem)(0.2),
    textTransform: 'uppercase',
    alignSelf: 'center'
  },
  h5: {
    fontFamily: "'Open Sans', sans-serif",
    fontWeight: 700,
    fontSize: (0, _misc.pxToRem)(22),
    lineHeight: (0, _misc.pxToRem)(30),
    letterSpacing: (0, _misc.pxToRem)(0.1),
    alignSelf: 'center'
  },
  subtitle1: {
    fontFamily: "'Open Sans', sans-serif",
    fontWeight: 400,
    fontSize: (0, _misc.pxToRem)(10),
    lineHeight: (0, _misc.pxToRem)(12),
    letterSpacing: (0, _misc.pxToRem)(0.2),
    alignSelf: 'center'
  },
  body1: {
    fontFamily: "'Open Sans', sans-serif",
    fontWeight: 400,
    fontSize: (0, _misc.pxToRem)(16),
    lineHeight: (0, _misc.pxToRem)(24),
    letterSpacing: (0, _misc.pxToRem)(0.2),
    alignSelf: 'center'
  },
  body2: {
    fontFamily: "'Open Sans', sans-serif",
    fontWeight: 400,
    fontSize: (0, _misc.pxToRem)(12),
    lineHeight: (0, _misc.pxToRem)(18),
    letterSpacing: (0, _misc.pxToRem)(0.1),
    alignSelf: 'center'
  },
  button: {
    fontFamily: "'Open Sans', sans-serif",
    fontWeight: 700,
    fontSize: (0, _misc.pxToRem)(16),
    lineHeight: (0, _misc.pxToRem)(16),
    letterSpacing: (0, _misc.pxToRem)(0.2),
    textTransform: 'capitalize',
    alignSelf: 'center'
  },
  caption: {
    fontFamily: "'Open Sans', sans-serif",
    fontWeight: 600,
    fontSize: (0, _misc.pxToRem)(16),
    lineHeight: (0, _misc.pxToRem)(24),
    letterSpacing: (0, _misc.pxToRem)(0.2),
    alignSelf: 'center'
  }
};
exports.sizes = sizes;

var _default = _objectSpread({
  fontFamily: "'Open Sans', sans-serif",
  fontWeight: 600,
  lineHeight: 24,
  fontSize: 16,
  letterSpacing: 0.2,
  pxToRem: _misc.pxToRem
}, sizes);

exports["default"] = _default;